import { inject, Injectable } from '@angular/core';
import { AuthService, Customer, CustomerService } from 'gung-standard';
import { catchError, filter, first, Observable, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CarLinerCustomerService extends CustomerService {
  protected authService = inject(AuthService);

  getDefaultCustomer(noCache?: boolean): Observable<Customer> {
    return this.authService.getCurrentUser().pipe(
      filter(user => !!user),
      first(),
      switchMap(currentUser => {
        if (!!currentUser.extra?.preselectedCustomerId) {
          return this.getCustomer(currentUser.extra.preselectedCustomerId, noCache).pipe(
            catchError(() => this.getCustomer('GUNG_DEFAULT', noCache))
          );
        } else {
          return this.getCustomer('GUNG_DEFAULT', noCache);
        }
      })
    );
  }
}
